import styled from 'styled-components'

export const Slide = styled.div`
  width: 100vw;
  height: auto;
  display: block;
`
